import { render, staticRenderFns } from "./carousel-item.vue?vue&type=template&id=9b730448&scoped=true"
import script from "./carousel-item.vue?vue&type=script&lang=js"
export * from "./carousel-item.vue?vue&type=script&lang=js"
import style0 from "./carousel-item.vue?vue&type=style&index=0&id=9b730448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b730448",
  null
  
)

export default component.exports